import ConfirmationModal, { ConfirmationModalProps } from '@/components/Modals/ConfirmationModal';
import { useFormContext } from 'react-hook-form';

function RestoreOriginalConfirmationModal({ open, onClose }: Pick<ConfirmationModalProps, 'open' | 'onClose'>) {
    const { resetField, watch } = useFormContext();
    const selectedTranslationId = watch('selectedTranslationId');
    const sentences = watch(`captionsByTranslationId.${selectedTranslationId}.sentences`);

    function handleRestoreOriginal() {
        sentences.forEach((_: any, index: number) => {
            resetField(`captionsByTranslationId.${selectedTranslationId}.sentences.${index}.text`);
        });
        onClose();
    }

    return (
        <ConfirmationModal
            title="Restore original translation?"
            text={
                <>
                    This will undo all edits and restore the original text.
                    <br />
                    This action cannot be undone.
                    <br />
                    Are you sure you want to proceed?
                </>
            }
            primaryButtonText="Restore"
            secondaryButtonText="Cancel"
            onConfirm={handleRestoreOriginal}
            onSecondaryClick={onClose}
            onClose={onClose}
            open={open}
        />
    );
}

export default RestoreOriginalConfirmationModal;
